import React from "react";
import { StyledAnchor } from "./_styled";

export default function usePercLinkProcessor() {
  const processPercLink = ({ node, children }) => {
    const { target, "data-perc-an": an, "data-perc-db": db } = node.attribs;
    const href = `/perc-link?db=${db}&an=${an}`;

    return (
      <StyledAnchor target={target} href={href}>
        {children}
      </StyledAnchor>
    );
  };

  return { processPercLink };
}
